import { SensorPort, SensorType } from '../common/enums'
import { DirtTrackerMode } from '../common/constants'

const MIN_CUBIC_YARDS_PER_DUMP = 0

interface Props {
  sensorPort: SensorPort
  sensorType: SensorType
  secondarySensorPort?: SensorPort
  secondarySensorType?: SensorType
  currentRate: number
  lastReading: string
  antiShakeFilter: boolean
  dumps: number
  totalHoursOfService: number
  mode: DirtTrackerMode
  dumpVolume: number
  setDumpVolume: (value: number) => void
  toggleAntiShakeFilter: () => void
  setRicVolumePerDump: (ricVolumePerDump: number) => void
}

export function ChartSubHeaderDumpVolume({
  sensorPort,
  sensorType,
  secondarySensorPort,
  secondarySensorType,
  currentRate,
  lastReading,
  antiShakeFilter,
  dumps,
  totalHoursOfService,
  mode,
  dumpVolume,
  setDumpVolume,
  toggleAntiShakeFilter,
  setRicVolumePerDump,
}: Props) {
  const lookup: Partial<Record<SensorType, string>> = {
    [SensorType.CountButtonCB100]: 'CB100',
    [SensorType.TiltSensorTS100]: 'TS100',
    [SensorType.ServiceButtonSB100]: 'SB100',
  }

  // This is a total hack
  const total = {
    dumps: mode === 'Dumps' ? dumps : dumps / dumpVolume,
    dumpVolume: mode === 'Cubic Yards' ? dumps : dumps * dumpVolume,
  }

  let ricSensorInfo = `${sensorPort}: ${lookup[sensorType] || 'unknown'}`
  ricSensorInfo +=
    secondarySensorType && secondarySensorType !== SensorType.None
      ? ` ${secondarySensorPort}: ${lookup[secondarySensorType]}`
      : ''

  return (
    <div className={tailwind.chartSubHeader}>
      <table className={tailwind.table}>
        <tbody>
          <tr className={tailwind.topTableRow}>
            <td>{ricSensorInfo}</td>
            <td>{`Current: ${currentRate} ${mode === 'Cubic Yards' ? 'cu yd' : 'dumps'} / hr`}</td>
            <td>{`Last Reading: ${lastReading}`}</td>
          </tr>
          <tr className="text-sm">
            <td className="pr-10">
              <div className="flex flex-row">
                <input
                  className={tailwind.inputText}
                  type="number"
                  id="alert-email"
                  placeholder={'volume per dump'}
                  value={dumpVolume}
                  min={MIN_CUBIC_YARDS_PER_DUMP}
                  onChange={(e) => {
                    setDumpVolume(parseInt(e.target.value) || MIN_CUBIC_YARDS_PER_DUMP)
                  }}
                />
                <div className="pt-0.5 pl-3">cu yd / dump</div>
              </div>
            </td>
            <td>
              {sensorType === SensorType.TiltSensorTS100 && (
                <button onClick={toggleAntiShakeFilter}>{`Anti-Shake Filter: ${
                  antiShakeFilter ? 'ON' : 'OFF'
                }`}</button>
              )}
            </td>
            <td>
              <div className="flex flex-row">
                {mode === 'Dumps' ? `Total: ${total.dumps} dumps` : `Total: ${total.dumpVolume} cu yd`}
                {totalHoursOfService > 0 && ` ${totalHoursOfService} hrs`}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const tailwind = {
  chartSubHeader: 'text-black text-l font-regular bg-[#DDD] pl-4 pr-4 w-full',

  table: 'table-fixed w-full',

  topTableRow: 'h-8 text-sm',

  inputText:
    'appearance-none border border-red-500 rounded w-full pt-0.5 px-1 mb-1 text-sm text-gray-700 leading-tight focus:outline-none cursor-pointer w-20',

  inputDropdown:
    'appearance-none border border-red-500 rounded w-full py-2 px-3 text-sm text-gray-700 leading-tight focus:outline-none cursor-pointer',

  lockIcon: 'w-10 pt-2 pl-3 cursor-pointer',
}
